import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_CRM_API_URL,
});

// Optional: add interceptors
api.interceptors.request.use(
  (config) => {
    // Example: attach token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // handle 401, 500 etc.
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export default api;